/***************************************************************************************
 * @module       App 
 * @name         App
 * @description  Main application component that sets up routing and global components
 * @version      1.0.0
 * @license      Licensed under the MIT License
 * @createdon    May 2025
 * @since        1.0
 ***************************************************************************************/

import React,{useEffect,Suspense} from "react";
import router from './routes/techus-mainRoutes';
import { RouterProvider } from 'react-router-dom';
import { useDispatch } from 'react-redux'; 
import './assets/index.css';
import './assets/common.css';
import './assets/Animations/animations.css';
import './assets/icons/style.css';

import ToastNotification from "./genriccomponents/techus-ToastNotification";
import ErrorBoundary from "./genriccomponents/techus-errorBoundary";

import { fetchSession } from './reduxtoolbox/actions/authSlice';
import Loader from "./genriccomponents/loaders/RedLoader";
function App() {
  const dispatch = useDispatch();

  useEffect(() => {
   if(localStorage.getItem('user_access_token')!==null){
    dispatch(fetchSession());
   }
  }, []);

const resizeObserverErrMsg = 'ResizeObserver loop completed with undelivered notifications.';
window.addEventListener('error', e => {
  if (e.message === resizeObserverErrMsg) {
    e.stopImmediatePropagation();
  }
});

  return (
    <>
    <Suspense fallback={<Loader />}>
       <ErrorBoundary>
        <RouterProvider router={router} />
        <ToastNotification />
      </ErrorBoundary>
      </Suspense>
    </>
  );
}

export default App;
